import { render } from "./score.vue?vue&type=template&id=6141cf42&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=6141cf42&lang=scss&scoped=true"
import "./score.vue?vue&type=style&index=1&id=6141cf42&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6141cf42"]])

export default __exports__